import { render, staticRenderFns } from "./AffiliateCustomers.vue?vue&type=template&id=d879c8f0&scoped=true&"
import script from "./AffiliateCustomers.vue?vue&type=script&lang=js&"
export * from "./AffiliateCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d879c8f0",
  null
  
)

export default component.exports